import moment from "moment";
import { CheckboxField, Grid, Loader, TextField } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import { API, graphqlOperation } from "aws-amplify";
import { useContext, useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

import { getEquipment } from "graphql/queries";
import { globalStrings } from "config/translations/es";
import { ScheduleContext } from "components/maintenanceSchedules/context/ScheduleContext";

const ServiceOrderCard = ({ serviceOrder, equipmentID }) => {
  const { updateEvent } = useContext(ScheduleContext);
  const [equipmentState, setEquipmentState] = useState({});
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    let { name, value, checked } = e.target;
    if (value && (name === "start" || name === "end"))
      value = moment(value).toDate();
    if (name === "geolocation") value = checked;
    updateEvent({ id: serviceOrder.id, [name]: value });
  };

  async function fetchEquipment(id) {
    try {
      setLoading(true);
      const equipmentData = await API.graphql(
        graphqlOperation(getEquipment, {
          id,
        })
      );
      const equipmentItem = equipmentData.data.getEquipment;
      setEquipmentState(equipmentItem);
    } catch (err) {
      console.log("Error fetchEquipment", err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchEquipment(equipmentID);
  }, [equipmentID]);

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        {serviceOrder.code && (
          <div>
            <span>{strings.serviceOrderDetails.serviceOrder}: </span>
            <span className="text-muted">{serviceOrder.code}</span>
          </div>
        )}
        {loading ? (
          <Loader />
        ) : (
          equipmentState.name && (
            <div>
              <span>{strings.serviceOrderDetails.equipment}: </span>
              <span className="text-muted">{equipmentState.name}</span>
            </div>
          )
        )}
        {serviceOrder.status && (
          <div>
            <span>{strings.serviceOrderDetails.status}: </span>
            <span className="text-muted">
              {globalStrings.serviceOrderStatus[serviceOrder.status]}
            </span>
          </div>
        )}
        {serviceOrder.title && (
          <TextField
            name="title"
            label={strings.serviceOrderDetails.name}
            value={serviceOrder.title}
            onChange={onChange}
          />
        )}
        {serviceOrder.description && (
          <div>
            <span>{strings.serviceOrderDetails.description}: </span>
            <span className="text-muted">{serviceOrder.description}</span>
          </div>
        )}
        {serviceOrder.start && (
          <TextField
            name="start"
            type="datetime-local"
            label={strings.serviceOrderDetails.start}
            value={moment(serviceOrder.start).format("YYYY-MM-DDTHH:mm:ss")}
            onChange={onChange}
          />
        )}
        {serviceOrder.end && (
          <TextField
            name="end"
            type="datetime-local"
            label={strings.serviceOrderDetails.end}
            value={moment(serviceOrder.end).format("YYYY-MM-DDTHH:mm:ss")}
            onChange={onChange}
          />
        )}
        <CheckboxField
          name="geolocation"
          label={strings.serviceOrderDetails.geolocation}
          checked={serviceOrder.geolocation || false}
          onChange={onChange}
        ></CheckboxField>
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    serviceOrderDetails: {
      serviceOrder: "Orden de Servicio",
      equipment: "Equipo",
      status: "Estado",
      name: "Nombre",
      description: "Descripción",
      start: "Fecha Inicio de Ejecución",
      end: "Fecha Final de Ejecución",
      geolocation: "Activar geolocalización para la ejecución",
    },
  },
});

export default ServiceOrderCard;
